import { combineReducers } from "redux";

import { reduceFormInitialization } from "./initialize";
import { reduceFields } from "./fields";
import { reduceSchema } from "./schema";
import { reduceErrors } from "./errors";

export const REMOVE_FIELD = "REMOVE_FIELD";

export function removeField(formKey, fieldName) {
  return {
    type: REMOVE_FIELD,
    formKey,
    fieldName
  };
}

function removeFieldHandler(originalFormState, fieldName) {
  const formState = { ...originalFormState };

  if (formState.fields) delete formState.fields[fieldName];
  if (formState.schema) delete formState.schema[fieldName];
  if (formState.errors) delete formState.errors[fieldName];

  return formState;
}

const formFieldsReducer = combineReducers({
  fields: reduceFields,
  schema: reduceSchema,
  errors: reduceErrors
});

export default function formReducer(state, action) {
  const formKey = action.formKey;

  // When no formKey is provided, this is not a form-related action
  if (!formKey) {
    return state || {};
  }

  // Apply reducers to the form's state
  let updatedFormState = reduceFormInitialization(state, action);

  switch (action.type) {
    case REMOVE_FIELD:
      updatedFormState = removeFieldHandler(
        updatedFormState[formKey] || {},
        action.fieldName
      );
      break;

    default:
      updatedFormState = formFieldsReducer(updatedFormState[formKey] || {}, action);
      break;
  }

  // Return the updated state for all the forms
  return { ...state, [formKey]: updatedFormState };
}
